// Lightweight city-name normalization used to catch the most common ways the
// same city ends up typed differently — trailing state abbreviations, extra
// whitespace, casing. This is a heuristic, not real geocoding: it won't catch
// things like "NYC" vs "New York" or international variants. If city data
// volume grows, replace this with a real places/geocoding autocomplete
// (e.g. Google Places) so members pick from real matches instead of typing
// free text at all.

const US_STATE_ABBREVIATIONS = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY",
];

const STATE_SUFFIX_RE = new RegExp(`,?\\s*(${US_STATE_ABBREVIATIONS.join("|")})$`, "i");

/**
 * Normalize a city string for comparison purposes only (never for display).
 * "Boston", "boston", "Boston, MA", "  Boston  " all normalize to "boston".
 */
export function normalizeCity(raw) {
  if (!raw) return "";
  return raw
    .trim()
    .replace(/\s+/g, " ")
    .replace(STATE_SUFFIX_RE, "")
    .trim()
    .toLowerCase();
}

/**
 * Given a list of existing city display-strings, find ones that normalize to
 * the same value as `input` (excluding exact/blank matches when useful).
 */
export function findMatchingCities(input, existingCities) {
  const normalizedInput = normalizeCity(input);
  if (!normalizedInput) return [];
  return existingCities.filter((c) => normalizeCity(c).includes(normalizedInput) || normalizedInput.includes(normalizeCity(c)));
}